<template>
  <div class="company-appointment-box">
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz1.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz2.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz3.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz4.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz5.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz6.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz7.png'" />
    <img class="banner" :src="cdnresources + '/prod/images/xiangaibao/lpxz8.png'" />
    <div class="lpitemBox">
      <div class="box-title">
        <div class="box-text">
          特定药械清单目录
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <!-- <img
        class="banner"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz9.png'"
      /> -->
      <table border="1" cellspacing="0" class="yaotable">
        <tbody>
          <!-- <tr class="tableHead">
            <td colspan="6">特药清单</td>
          </tr> -->
          <tr class="tableHead">
            <td>
              序号
            </td>
            <td>
              商品名
            </td>
            <td>
              通用名
            </td>
            <td>
              厂家
            </td>
            <td>
              适应疾病
            </td>
            <td>
              指定适应症
            </td>
          </tr>

          <tr>
            <td>1</td>
            <td>唯可来</td>
            <td>维奈克拉片</td>
            <td>艾伯维</td>
            <td>白血病</td>
            <td>
              本品与阿扎胞苷联合用于治疗因合并症不适合接受强诱导化疗，或者年龄75岁及以上的新诊断的成人急性髓系白血病患者
            </td>
          </tr>

          <tr>
            <td>2</td>
            <td>耐立克</td>
            <td>奥雷巴替尼片</td>
            <td>亚盛医药</td>
            <td>白血病</td>
            <td>
              本品用于任何酪氨酸激酶抑制剂耐药，并采用经充分验证的检测方法诊断为伴有T315I突变的慢性髓细胞白血病慢性期或加速期的成年患者
            </td>
          </tr>

          <tr>
            <td>3</td>
            <td>适加坦</td>
            <td>富马酸吉瑞替尼片</td>
            <td>安斯泰来</td>
            <td>白血病</td>
            <td>
              用于治疗携带FLT3突变的复发性或难治性急性髓系白血病（AML）成人患者。
            </td>
          </tr>

          <tr>
            <td>4</td>
            <td>拓舒沃</td>
            <td>艾伏尼布</td>
            <td>基石药业</td>
            <td>白血病</td>
            <td>
              本品适用于采用经充分验证的检测方法诊断为携带易感异柠檬酸脱氢酶-1（IDH1）突变的复发性或难治性急性髓系白血病（AML）成人患者。
            </td>
          </tr>

          <tr>
            <td>5</td>
            <td>拓益</td>
            <td>特瑞普利单抗注射液</td>
            <td>君实</td>
            <td>鼻咽癌</td>
            <td>
              联合顺铂和吉西他滨用于局部复发或转移性鼻咽癌患者的一线治疗
            </td>
          </tr>

          <tr>
            <td>6</td>
            <td>凯洛斯</td>
            <td>注射用卡非佐米</td>
            <td>百济神州</td>
            <td>多发性骨髓瘤</td>
            <td>
              用于与地塞米松联合适用于治疗复发或难治性（R/R）多发性骨髓瘤（MM）成人患者，患者既往至少接受过2种治疗，包括蛋白酶体抑制剂和免疫调节剂。
            </td>
          </tr>

          <tr>
            <td>7</td>
            <td>法布赞</td>
            <td>注射用阿加糖酶β</td>
            <td>赛诺菲</td>
            <td>法布雷病</td>
            <td>
              本品适用于被确诊为法布雷病( Fabry disease,α-半乳糖苷酶 A
              缺乏)患者的长期酶替代疗法。<br />
              本品适用于成人、8 岁及以上的儿童和青少年
            </td>
          </tr>

          <tr>
            <td>8</td>
            <td>阿美乐</td>
            <td>甲磺酸阿美替尼片</td>
            <td>江苏豪森药业</td>
            <td>肺癌</td>
            <td>
              用于具有表皮生长因子受体外显子19缺失或外显子21（L858R）置换突变的局部晚期或转移性非小细胞肺癌成人患者的一线治疗。
            </td>
          </tr>

          <tr>
            <td>9</td>
            <td>普吉华</td>
            <td>普拉替尼</td>
            <td>基石制药</td>
            <td>肺癌</td>
            <td>
              用于既往接受过含铂化疗的转染重排（RET）基因融合阳性的局部晚期或转移性非小细胞肺癌（NSCLC）成人患者的治疗
            </td>
          </tr>

          <tr>
            <td>10</td>
            <td>英飞凡</td>
            <td>度伐利尤单抗</td>
            <td>阿斯利康</td>
            <td>肺癌</td>
            <td>
              1、本品适用于在接受铂类药物为基础的化疗同步放疗后未出现疾病进展的不可切除、III
              期非小细胞肺癌(NSCLC)患者的治疗。<br />
              2、与依托泊苷联合铂类（卡铂或顺铂）化疗方案联合，用于广泛期小细胞肺癌的一线治疗。
            </td>
          </tr>

          <tr>
            <td>11</td>
            <td>择捷美</td>
            <td>舒格利单抗注射液</td>
            <td>基石药业</td>
            <td>肺癌</td>
            <td>
              适用于联合培美曲塞和卡铂用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌患者的一线治疗，以及联合紫杉醇和卡铂用于转移性鳞状非小细胞肺癌
              （NSCLC） 患者的一线治疗。
            </td>
          </tr>

          <tr>
            <td>12</td>
            <td>艾弗沙</td>
            <td>伏美替尼</td>
            <td>艾力斯</td>
            <td>肺癌</td>
            <td>
              用于具有表皮生长因子受体(EGFR)外显子19缺失突变(19DEL)或外显子21置换突变(21L858R)的局部晚期或转移性非小细胞肺癌(NSCLC)成人患者的一线治疗
            </td>
          </tr>

          <tr>
            <td>13</td>
            <td>可瑞达</td>
            <td>帕博利珠单抗注射液</td>
            <td>默沙东</td>
            <td>
              肺癌、黑色素瘤、头颈部鳞状细胞癌、结直肠癌
            </td>
            <td>
              1.黑色素瘤<br />
              帕博利珠单抗适用于经一线治疗失败的不可切除或转移性黑色素瘤的治疗。<br />
              2.非小细胞肺癌<br />
              帕博利珠单抗适用于由国家药品监督管理局批准的检测评估为 PD-L1
              肿瘤比例分数（TPS） ≥ 1%
              的表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的局部晚期或转移性非小细胞肺癌一线单药治疗。<br />
              帕博利珠单抗联合培美曲塞和铂类化疗适用于表皮生长因子受体（EGFR）基因突变阴性和间变性淋巴瘤激酶（ALK）阴性的转移性非鳞状非小细胞肺癌（NSCLC）的一线治疗。<br />
              帕博利珠单抗联合卡铂和紫杉醇适用于转移性鳞状非小细胞肺癌（NSCLC）患者的一线治疗。<br />
              3.头颈部鳞状细胞癌<br />
              用于通过充分验证的检测评估肿瘤表达PD-L1（综合阳性评分[CPS]≥20）的转移性或不可切除的复发性头颈部鳞状细胞癌（HNSCC）患者的一线治疗。<br />
              4.单药用于KRAS、NRAS和BRAF基因均为野生型，不可切除或转移性高微卫星不稳定性（MSI-H）或错配修复基因缺陷型（dMMR）结直肠癌（CRC）患者的一线治疗。
            </td>
          </tr>

          <tr>
            <td>14</td>
            <td>芮旎爾</td>
            <td>曲前列尼尔注射液</td>
            <td>兆科药业</td>
            <td>肺动脉高压</td>
            <td>
              本品用于治疗肺动脉高压（PAH，WHO分类
              1），以减轻运动引起的相关症状。
            </td>
          </tr>

          <tr>
            <td>15</td>
            <td>泰圣奇</td>
            <td>阿替利珠单抗</td>
            <td>罗氏制药</td>
            <td>肝癌</td>
            <td>
              阿替利珠单抗联合贝伐珠单抗治疗既往未接受过全身系统性治疗的不可切除肝细胞癌患者
            </td>
          </tr>

          <tr>
            <td>16</td>
            <td>思而赞</td>
            <td>注射用伊米苷酶</td>
            <td>赛诺菲</td>
            <td>戈谢病</td>
            <td>
              用于确诊患有导致下列一种或多种病症的Ⅰ型戈谢氏病（Gaucher
              disease）的儿童及成人患者的长期酶替代疗法。（贫血，血小板减少症，骨病，肝肿大，脾肿大）
            </td>
          </tr>

          <tr>
            <td>17</td>
            <td>爱地希</td>
            <td>注射用维迪西妥单抗</td>
            <td>荣昌生物</td>
            <td>尿路上皮癌</td>
            <td>
              用于既往接受过系统化疗且 HER2 表达<br />
              为免疫组化检查结果为 2+ 或 3+ 的局部晚期或转移性尿路上皮癌的患者
            </td>
          </tr>

          <tr>
            <td>18</td>
            <td>赫赛莱</td>
            <td>恩美曲妥珠单抗</td>
            <td>罗氏制药</td>
            <td>乳腺癌</td>
            <td>
              1、赫赛莱单药适用于接受了紫杉烷类联合曲妥珠单抗为基础的新辅助治疗后仍残存侵袭性病灶的HER2阳性早期乳腺癌患者的辅助治疗。<br />
              2、单药治疗接受了紫杉烷类和曲妥珠单抗治疗的HER2阳性、不可切除局部晚期或转移性乳腺癌患者，且患者应具备以下任一情形：既往接受过针对局部晚期或转移性乳腺癌的治疗，或在辅助治疗期间或完成辅助治疗后6个月内出现疾病复发。
            </td>
          </tr>

          <tr>
            <td>19</td>
            <td>多恩达</td>
            <td>
              盐酸米托蒽醌脂质体注射液
            </td>
            <td>石药集团</td>
            <td>淋巴瘤</td>
            <td>
              本品适应于既往至少经过一线标准治疗的复发或难治的外周T细胞淋巴瘤（PTCL）成人患者
            </td>
          </tr>

          <tr>
            <td>20</td>
            <td>爱普盾</td>
            <td>肿瘤电场治疗</td>
            <td>再鼎医药</td>
            <td>脑瘤</td>
            <td>
              适用于22岁及以上经组织病理学或影像学诊断的复发性幕上胶质母细胞瘤（GBM）及新诊断的幕上GBM。其中，新诊断的GBM患者中，在手术治疗与放射治疗后，本产品与替莫唑胺（TMZ）联合使用，在复发性GBM患者中本产品为单一治疗方法
            </td>
          </tr>

          <tr>
            <td>21</td>
            <td>
              人工耳蜗植入体 Cochlear Implant
            </td>
            <td>
              人工耳蜗植入体 Cochlear Implant
            </td>
            <td>科利耳</td>
            <td>
              重度或极重度感音神经性耳聋
            </td>
            <td>
              重度或极重度感音神经性耳聋
            </td>
          </tr>

          <tr>
            <td>22</td>
            <td>海芮思</td>
            <td>艾度硫酸酯酶β注射液</td>
            <td>北海康成</td>
            <td>黏多糖贮积症II型</td>
            <td>
              用于确诊的黏多糖贮积症II型（MPS II，亨特综合征）患者的酶替代治疗。
            </td>
          </tr>

          <tr>
            <td>23</td>
            <td>美而赞</td>
            <td>注射用阿糖甘酶α</td>
            <td>赛诺菲</td>
            <td>庞贝病</td>
            <td>
              注射用阿糖苷酶α是一种溶酶体糖原特异性水解酶，用于庞贝病（酸性α-葡萄糖苷酶[GAA]缺乏症）患者的治疗。
            </td>
          </tr>

          <tr>
            <td>24</td>
            <td>爱博新</td>
            <td>哌柏西利胶囊</td>
            <td>辉瑞</td>
            <td>乳腺癌</td>
            <td>
              本品适用于激素受体(HR)阳性、人表皮生长因子受体 2
              (HER2)阴性的局部晚期或转移性乳腺癌，应与芳香化酶抑制剂联合使用作为绝经后女性患者的初始内分泌治疗
            </td>
          </tr>

          <tr>
            <td>25</td>
            <td>艾瑞康</td>
            <td>羟乙磺酸达尔西利片</td>
            <td>江苏恒瑞</td>
            <td>乳腺癌</td>
            <td>
              联合氟维司群用于激素受体（HR）阳性，人表皮因子受体2（HER2）阴性的经内分泌治疗后进展的复发或转移性乳腺癌的治疗
            </td>
          </tr>

          <tr>
            <td>26</td>
            <td>贝安汀</td>
            <td>贝伐珠单抗注射液</td>
            <td>海正生物制药</td>
            <td>
              上皮性卵巢癌、输卵管癌或原发性腹膜癌、宫颈癌
            </td>
            <td>
              1、上皮性卵巢癌、输卵管癌或原发性腹膜癌<br />
              贝伐珠单抗联合卡铂和紫杉醇用于初次手术切除后的 III 期或 IV
              期上皮性卵巢癌、输卵管癌或原发性腹膜癌患者的一线治疗。<br />
              2、宫颈癌<br />
              贝伐珠单抗联合紫杉醇和顺铂或紫杉醇和托泊替康用于持续性、复发性或转移性宫颈癌患者的治疗。
            </td>
          </tr>

          <tr>
            <td>27</td>
            <td>艾瑞卡</td>
            <td>注射用卡瑞利珠单抗</td>
            <td>江苏恒瑞</td>
            <td>食管癌、鼻咽癌</td>
            <td>
              1、联合紫杉醇和顺铂用于晚期食管癌一线治疗<br />
              2、用于既往接受过二线及以上化疗后疾病进展或不可耐受的晚期鼻咽癌患者的治疗。<br />
              3、本品联合顺铂和吉西他滨用于局部复发或转移性鼻咽癌患者的一线治疗。
            </td>
          </tr>

          <tr>
            <td>28</td>
            <td>擎乐</td>
            <td>瑞派替尼</td>
            <td>再鼎医药</td>
            <td>胃肠道间质瘤</td>
            <td>
              用于已治疗接受过包括伊马替尼在内的3种及以上激酶抑制剂治疗的晚期胃肠道间质瘤（GIST）成人患者。
            </td>
          </tr>

          <tr>
            <td>29</td>
            <td>欧狄沃</td>
            <td>纳武利尤单抗注射液</td>
            <td>百时美施贵宝</td>
            <td>胃或胃食管连接部腺癌</td>
            <td>
              胃腺癌和胃食道连接部腺癌<br />
              本品可用于治疗既往接受过两种或两种以上全身性治疗方案的晚期或复发性胃或胃食管连接部腺癌患者
            </td>
          </tr>

          <tr>
            <td>30</td>
            <td>唯铭赞</td>
            <td>依洛硫酸酯酶</td>
            <td>百傲万里</td>
            <td>IVA 型黏多糖贮积症</td>
            <td>
              本品适用于 IVA 型黏多糖贮积症患者（MPS IVA，Morquio A 综合征）
            </td>
          </tr>

          <tr>
            <td>31</td>
            <td>Daurismo</td>
            <td>Glasdegib/格拉吉布</td>
            <td>辉瑞</td>
            <td>白血病</td>
            <td>
              适用于与低剂量阿糖胞苷联合使用，用于在不能使用强化诱导化疗的 ≥ 75
              岁或患有合并疾病的成年患者中治疗新诊断的急性髓细胞性白血病（AML）。
            </td>
          </tr>

          <tr>
            <td>32</td>
            <td>Onureg</td>
            <td>
              Azacitidine/阿扎胞苷片
            </td>
            <td>施贵宝</td>
            <td>白血病</td>
            <td>
              强化诱导化疗后首次达到完全缓解（CR）或完全缓解伴血细胞计数不完全恢复（CRi）且不能完成强化治愈性治疗的急性髓系白血病（AML）成人患者的持续治疗。
            </td>
          </tr>

          <tr>
            <td>33</td>
            <td>Truseltiq</td>
            <td>
              infigratinib/英菲格拉替尼
            </td>
            <td>联拓生物</td>
            <td>胆管癌</td>
            <td>
              用于成人既往接受过治疗的、不可切除的局部晚期或转移性的伴有成纤维细胞生长因子受体
              2（FGFR2）融合或其他重排（可通过 FDA
              批准的检测方法来检测）的胆管癌患者。
            </td>
          </tr>

          <tr>
            <td>34</td>
            <td>Sarclisa</td>
            <td>
              isatuximab-irfc/赛可益注射液
            </td>
            <td>赛诺菲</td>
            <td>多发性骨髓瘤</td>
            <td>
              1.与泊马度胺和地塞米松联用，治疗既往接受过至少两种治疗（包含来那度胺和一种蛋白酶体抑制剂，并在最后一次治疗中表现出疾病进展）的复发和难治性多发性骨髓瘤成年患者。<br />
              2.与卡非佐米和地塞米松联用，治疗既往接受过至少一种治疗的多发性骨髓瘤成人患者。
            </td>
          </tr>

          <tr>
            <td>35</td>
            <td>Wakix</td>
            <td>Pitolisant/替洛利生</td>
            <td>琅铧医药</td>
            <td>发作性睡病</td>
            <td>
              成人伴或不伴猝倒的发作性睡病。
            </td>
          </tr>

          <tr>
            <td>36</td>
            <td>Lumakras</td>
            <td>Sotorasib/索托雷塞</td>
            <td>百济神州</td>
            <td>肺癌</td>
            <td>
              适用于治疗既往接受过至少1种全身治疗的KRAS
              G12C突变型局部晚期或转移性非小细胞肺癌（NSCLC）成人患者。
            </td>
          </tr>

          <tr>
            <td>37</td>
            <td>Tepmetko</td>
            <td>Tepotinib/特泊替尼</td>
            <td>默克</td>
            <td>肺癌</td>
            <td>
              含MET外显子14跳跃突变的局晚及转移性非小细胞肺癌（NSCLC）一线及后线治疗。
            </td>
          </tr>

          <tr>
            <td>38</td>
            <td>Tabrecta</td>
            <td>
              Capmatinib/卡马替尼片
            </td>
            <td>诺华肿瘤</td>
            <td>肺癌</td>
            <td>
              治疗转移性非小细胞肺癌（NSCLC）成人患者，这些患者的肿瘤突变导致间质-上皮转化（MET）外显子14
              跳跃突变
            </td>
          </tr>

          <tr>
            <td>39</td>
            <td>Braftovi</td>
            <td>Encorafenib/康奈非尼</td>
            <td>皮尔法伯</td>
            <td>黑色素瘤、结直肠癌</td>
            <td>
              1、与binimetinib联合使用，用于治疗患有不可切除性或转移性黑色素瘤伴BRAF
              V600突变的成年患者；<br />
              2、与西妥昔单抗联合使用，用于治疗患有转移性结肠直肠癌（CRC）伴BRAF
              V600E突变，且曾经接受过系统治疗的成人患者。
            </td>
          </tr>

          <tr>
            <td>40</td>
            <td>Tazverik</td>
            <td>
              tazemetostat/他泽司他
            </td>
            <td>和黄医药</td>
            <td>淋巴瘤、上皮样肉瘤</td>
            <td>
              1.
              用于治疗无法完全手术切除的转移性或局部晚期上皮样肉瘤成人及16岁以上儿童患者<br />
              2.
              用于EZH2突变且既往接受过至少2种全身系统治疗的复发性或难治性滤泡性淋巴瘤成人患者的治疗<br />
              3. 用于无合适的可替代治疗方案的复发性或难治性滤泡性淋巴瘤
              成人患者的治疗
            </td>
          </tr>

          <tr>
            <td>41</td>
            <td>Balversa</td>
            <td>
              Erdafitinib/厄达替尼片
            </td>
            <td>西安杨森</td>
            <td>尿路上皮癌</td>
            <td>
              患有局部晚期或转移性尿路上皮癌(metastaticurothelial carcinoma,
              mUC)成年患者的治疗，需要满足：存在FGFR3或FGFR2易感型基因改变，以及既往接受过至少一线含铂化疗且化疗期间或之后出现疾病进展，包括在接受含铂新辅助化疗或辅助化疗后的12个月内出现疾病进展。
            </td>
          </tr>

          <tr>
            <td>42</td>
            <td>Bavencio</td>
            <td>Avelumab/阿维鲁单抗</td>
            <td>默克</td>
            <td>
              尿路上皮癌、肾细胞癌、默克尔细胞癌(MCC)
            </td>
            <td>
              默克氏细胞癌;肾细胞癌;泌尿道上皮细胞癌。
            </td>
          </tr>

          <tr>
            <td>43</td>
            <td>Talzenna</td>
            <td>
              Talazoparib/他拉唑帕尼
            </td>
            <td>辉瑞</td>
            <td>乳腺癌</td>
            <td>
              Talazoparib是一种聚腺苷二磷酸核糖聚合酶 (PARP)
              抑制剂，适用于治疗有害或疑似有害生殖系 BRCA 突变 (gBRCAm) HER2
              阴性局部晚期或转移性乳腺癌成人患者。
            </td>
          </tr>

          <tr>
            <td>44</td>
            <td>Phesgo</td>
            <td>
              Pertuzumab/trastuzumab/Hyaluronidase-zzxf/帕妥珠单抗/曲妥珠单抗/透明质酸酶-zzxf注射剂
            </td>
            <td>罗氏制药</td>
            <td>乳腺癌</td>
            <td>
              早期乳腺癌：<br />
              • 用于 HER2 阳性、局部晚期、炎性或早期乳腺癌患者（直径&gt;2 cm
              或淋巴结阳性）的新辅助治疗，作为早期乳腺癌整体治疗方案的一部分。<br />
              • 用于具有高复发风险 HER2 阳性早期乳腺癌患者的辅助治疗。<br />
              转移性乳腺癌：<br />
              • 本品和多西他赛联合，适用于
              HER2阳性、转移性或不可切除的局部复发性乳腺癌患者。针对转移性疾病，患者既往未接受过抗
              HER2 治疗或者化疗。
            </td>
          </tr>

          <tr>
            <td>45</td>
            <td>Enhertu</td>
            <td>
              Fam-trastuzumab
              deruxtecan-nxki，DS-8201/曲妥珠单抗重组冻干粉注射剂
            </td>
            <td>阿斯利康</td>
            <td>乳腺癌、胃癌</td>
            <td>
              1.有化疗史、HER2阳性的无法手术或复发性乳腺癌（仅限难以进行标准治疗的情况）。<br />
              2.癌症化疗后恶化的HER2阳性，且无法根治切除的进展/复发的胃癌。
            </td>
          </tr>

          <tr>
            <td>46</td>
            <td>Alkindi</td>
            <td>
              Hydrocortisone/氢化可的松可拆壳胶囊装颗粒剂
            </td>
            <td>琅铧医药</td>
            <td>肾上腺功能不全</td>
            <td>
              婴儿、儿童和青少年（出生至&lt; 18岁）肾上腺功能不全的替代疗法。
            </td>
          </tr>

          <tr>
            <td>47</td>
            <td>Foscan</td>
            <td>Temoporfin/替莫泊芬</td>
            <td>佰礼医药</td>
            <td>头颈部鳞状癌</td>
            <td>
              头颈颌面眼耳鼻喉部恶性肿瘤（鳞癌）。不能手术或不能放疗化疗的恶性肿瘤。
            </td>
          </tr>

          <tr>
            <td>48</td>
            <td>Efmody</td>
            <td>
              hydrocortisone/氢化可的松缓释硬胶囊
            </td>
            <td>琅铧医药</td>
            <td>
              先天性肾上腺皮质增生（CAH）
            </td>
            <td>
              适用于≥12岁的青少年及成人先天性肾上腺皮质增生（CAH）的替代治疗。
            </td>
          </tr>

          <tr>
            <td>49</td>
            <td>VYVGARTTM/卫伟迦</td>
            <td>
              Efgartigimod alfa-fcab/艾加莫德α注射液
            </td>
            <td>再鼎医药</td>
            <td>重症肌无力</td>
            <td>
              适用于治疗乙酰胆碱受体（AChR）抗体阳性的成人全身型重症肌无力患者。
            </td>
          </tr>

          <tr>
            <td>50</td>
            <td>LIVMARLI</td>
            <td>
              Maralixibat/马昔巴特口服液
            </td>
            <td>北海康成</td>
            <td>阿拉杰里综合征</td>
            <td>
              适用于治疗1岁及以上的阿拉杰里综合征（Alagille Syndrome,
              ALGS）患者的胆汁淤积性瘙痒。
            </td>
          </tr>

          <tr>
            <td>51</td>
            <td>奕凯达</td>
            <td>阿基仑赛注射液</td>
            <td>复星凯特生物</td>
            <td>淋巴瘤</td>
            <td>
              用于治疗二线或以上系统性治疗后复发或难治性大B细胞淋巴瘤成人患者，包括弥漫性大B细胞淋巴瘤（DLBCL）非特指型、原发性纵隔B细胞淋巴瘤（PMBCL）、高级别B细胞淋巴瘤和滤泡淋巴瘤转化的DLBCL。
            </td>
          </tr>

          <tr>
            <td>52</td>
            <td>倍诺达</td>
            <td>瑞基奥仑赛注射液</td>
            <td>药明巨诺</td>
            <td>淋巴瘤</td>
            <td>
              经过二线或以上系统性治疗后成人患者的复发或难治性大B细胞淋巴瘤，
              包括弥漫性大B细胞淋巴瘤非特指型、滤泡性淋巴瘤转化的弥漫性大B细
              胞淋巴瘤、3b级滤泡性淋巴瘤、原发纵隔大B细胞淋巴瘤、高级别B细胞
              淋巴瘤伴MYC和BCL-2和/或BCL-6重排(双打击/三打击淋巴瘤)。
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lpitemBox">
      <div class="box-title">
        <div class="box-text">
          指定药房清单
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <!-- <img
        class="banner"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz10.png'"
      /> -->
      <table class="yaotable" border="1" cellspacing="0">
        <tbody class="tbody">
          <tr class="tableHead">
            <td valign="center">
              <p><b>序号</b></p>
            </td>
            <td valign="center">
              <p><b>门店名</b></p>
            </td>
            <td valign="center">
              <p><b>地址</b></p>
            </td>
            <td valign="center">
              <p><b>电话</b></p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>1</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司湘雅分店</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市开福区清水塘街道华远华时代广场2054号（中南大学湘雅医院的儿科急诊正对面）
              </p>
            </td>
            <td valign="center">
              <p>0731-85046818</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>2</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司人民中路分店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市雨花区侯家塘街道电影公司门面人民中路170号</p>
            </td>
            <td valign="center">
              <p>0731-82250190</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>3</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司解放大道分店</p>
            </td>
            <td valign="center">
              <p>湖南省衡阳新附二东门30米</p>
            </td>
            <td valign="center">
              <p>0734-8169910</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>4</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司郴州青年大道分店</p>
            </td>
            <td valign="center">
              <p>湖南省郴州市北湖区燕泉街道青年大道15号9-10号门面</p>
            </td>
            <td valign="center">
              <p>0735-2331995</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>5</p>
            </td>
            <td valign="center">
              <p>益阳圆心药品有限公司</p>
            </td>
            <td valign="center">
              <p>湖南省益阳市赫山区秀峰西路289号一楼门面</p>
            </td>
            <td valign="center">
              <p>0737-6103650</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>6</p>
            </td>
            <td valign="center">
              <p>岳阳圆心药品有限公司</p>
            </td>
            <td valign="center">
              <p>湖南省岳阳市岳阳楼区巴陵尚都一栋101号铺面</p>
            </td>
            <td valign="center">
              <p>0730-8286580</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>7</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司浏阳人民医院分店</p>
            </td>
            <td valign="center">
              <p>湖南省浏阳市集里乡碧桂园时代城1幢106号铺面</p>
            </td>
            <td valign="center">
              <p>0731-83333365</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>8</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司韶山路分店</p>
            </td>
            <td valign="center">
              <p>长沙市雨花区雨花亭街道韶山路143号2006#号</p>
            </td>
            <td valign="center">
              <p>18570064001</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>9</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司常德分店</p>
            </td>
            <td valign="center">
              <p>湖南省常德市武陵区永安街道建设路致远东城悦府4栋108号商铺</p>
            </td>
            <td valign="center">
              <p>15200665553</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>10</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司株洲分店</p>
            </td>
            <td valign="center">
              <p>湖南省株洲市天元区泰山路街道滨江南路19号科艺花园8栋</p>
            </td>
            <td valign="center">
              <p>18173809887</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>11</p>
            </td>
            <td valign="center">
              <p>湖南圆心大药房有限公司娄底分店</p>
            </td>
            <td valign="center">
              <p>
                湖南省娄底市娄星区乐坪街道长青中街背面王家巷西侧王家小区3栋101
              </p>
            </td>
            <td valign="center">
              <p>15243822936</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>12</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司株洲店</p>
            </td>
            <td valign="center">
              <p>株洲市建设中路356号（火电科技大厦内）</p>
            </td>
            <td valign="center">
              <p>0731-22202096</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>13</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司长沙湘雅路店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市开福区湘雅路188号一楼、负一楼</p>
            </td>
            <td valign="center">
              <p>0731-84596109</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>14</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司岳阳步行街店</p>
            </td>
            <td valign="center">
              <p>岳阳市云梦路21号</p>
            </td>
            <td valign="center">
              <p>0730-8605527</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>15</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司益阳店</p>
            </td>
            <td valign="center">
              <p>益阳市赫山区康复北路106号（中心医院旁)</p>
            </td>
            <td valign="center">
              <p>0737-3100626</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>16</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司常德店</p>
            </td>
            <td valign="center">
              <p>常德市武陵区启明街道905号（市第一人民医院正对面）</p>
            </td>
            <td valign="center">
              <p>0736-7770217</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>17</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司邵阳红旗总店</p>
            </td>
            <td valign="center">
              <p>邵阳市大祥区大祥坪2号综合楼乾元巷4-7号一、二楼门面</p>
            </td>
            <td valign="center" nowrap="">
              <p>0739-5183836</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>18</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司娄底康一馨长青店</p>
            </td>
            <td valign="center">
              <p>娄底市娄星区长青中街33号</p>
            </td>
            <td valign="center" nowrap="">
              <p>0738-8680596</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>19</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司永州冷水滩一分店</p>
            </td>
            <td valign="center">
              <p>
                湖南省永州市冷水滩区河东永州大道与逸云路交叉口西北角永和家园5栋商业105
              </p>
            </td>
            <td valign="center" nowrap="">
              <p>0746-8666408</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>20</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司郴州北湖分店</p>
            </td>
            <td valign="center">
              <p>湖南省郴州市北湖区中山西街105号</p>
            </td>
            <td valign="center" nowrap="">
              <p>0735-2855518</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>21</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司湘潭韶山路分店</p>
            </td>
            <td valign="center">
              <p>湘潭市雨湖区雨湖路街道建设北路85号附1、2号</p>
            </td>
            <td valign="center" nowrap="">
              <p>0731-58531776</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>22</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司衡阳蒸湘北路分店</p>
            </td>
            <td valign="center">
              <p>湖南省衡阳市蒸湘区蒸湘北路33-5号四海大厦107室</p>
            </td>
            <td valign="center" nowrap="">
              <p>0734-8162910</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>23</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司湘乡三分店</p>
            </td>
            <td valign="center">
              <p>湘乡市昆仑桥办事处健康北路61-62号门面</p>
            </td>
            <td valign="center" nowrap="">
              <p>0731-56780058</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>24</p>
            </td>
            <td valign="center">
              <p>老百姓大药房连锁股份有限公司浏阳店</p>
            </td>
            <td valign="center">
              <p>浏阳市人民中路196号</p>
            </td>
            <td valign="center" nowrap="">
              <p>0731-83667188</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>25</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司长沙朝阳分店</p>
            </td>
            <td valign="center">
              <p>长沙市芙蓉区人民东路10号民基大厦一楼</p>
            </td>
            <td valign="center">
              <p>0731-84127158</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>26</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司湘潭基建营分店</p>
            </td>
            <td valign="center">
              <p>湘潭市基建营步步高往韶山东路50米</p>
            </td>
            <td valign="center">
              <p>0731-55579168</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>27</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司岳阳世纪星分店</p>
            </td>
            <td valign="center">
              <p>岳阳市云梦路1号世纪星商厦南部</p>
            </td>
            <td valign="center">
              <p>0730-8180688</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>28</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司衡阳东风路分店</p>
            </td>
            <td valign="center">
              <p>衡阳市东风路江东林隐福鑫酒楼旁</p>
            </td>
            <td valign="center">
              <p>0734-3178308</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>29</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司郴州罗家井分店</p>
            </td>
            <td valign="center">
              <p>郴州市北湖区国庆南路21号</p>
            </td>
            <td valign="center">
              <p>0735-2626755</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>30</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司益阳康复路分店</p>
            </td>
            <td valign="center">
              <p>益阳秀峰中路291号</p>
            </td>
            <td valign="center">
              <p>0737-4237666</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>31</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司张家界天门路分店</p>
            </td>
            <td valign="center">
              <p>湖南省张家界市永定区天门路339号</p>
            </td>
            <td valign="center">
              <p>0744-8385488</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>32</p>
            </td>
            <td valign="center">
              <p>益丰大药房连锁股份有限公司常德芷园分店</p>
            </td>
            <td valign="center">
              <p>常德市武陵区城东办事处半边街社区人民路977号</p>
            </td>
            <td valign="center">
              <p>0736-7312217</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>33</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司长沙梓园路店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市雨花区梓园路520号大财门公寓1层1003</p>
            </td>
            <td valign="center">
              <p>0731-85315595</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>34</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司长沙芙蓉路店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市开福区芙蓉中路一段319号绿地商业广场A108-1号</p>
            </td>
            <td valign="center">
              <p>0731-85815737</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>35</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司永州冷水滩店</p>
            </td>
            <td valign="center">
              <p>
                湖南省永州市冷水滩区永州大道与逸云路交叉口西北角永和家园5栋商业104、204、304号
              </p>
            </td>
            <td valign="center">
              <p>0746-8413635</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>36</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司岳阳巴陵中路店</p>
            </td>
            <td valign="center">
              <p>
                湖南省岳阳市岳阳楼区巴陵中路59号一楼大厅左侧（柴家山社区1网格）
              </p>
            </td>
            <td valign="center">
              <p>0730-8266908</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>37</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司怀化店</p>
            </td>
            <td valign="center">
              <p>湖南省怀化市鹤城区香洲水郡三期4幢1单元1层115号房</p>
            </td>
            <td valign="center">
              <p>0745-2311186</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>38</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司株洲滨江南路店</p>
            </td>
            <td valign="center">
              <p>湖南省株洲市天元区滨江南路19号科艺花园6栋109号（412007）</p>
            </td>
            <td valign="center">
              <p>0731-22501538</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>39</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司娄底石马店</p>
            </td>
            <td valign="center">
              <p>湖南省娄底市娄星区湘阳街富厚名邸0001栋1楼2号、2楼1号门面</p>
            </td>
            <td valign="center">
              <p>0738-8788110</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>40</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司湘潭书院路店</p>
            </td>
            <td valign="center">
              <p>
                湖南省湘潭市岳塘区书院路街道书院路21号西商住楼15号门面（411100）
              </p>
            </td>
            <td valign="center">
              <p>0731-58267839</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>41</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司吉首乾州店</p>
            </td>
            <td valign="center">
              <p>湖南省吉首市世纪大道21号市房地产管理局一楼临街门面12号</p>
            </td>
            <td valign="center">
              <p>0743-8229166</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>42</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司郴州店</p>
            </td>
            <td valign="center">
              <p>湖南省郴州市苏仙区南塔街道南塔市场209号</p>
            </td>
            <td valign="center">
              <p>0735-2298701</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>43</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司衡阳船山西路店</p>
            </td>
            <td valign="center">
              <p>湖南省衡阳市蒸湘区船山西路3号</p>
            </td>
            <td valign="center">
              <p>0734-8168209</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>44</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司益阳康富路店</p>
            </td>
            <td valign="center">
              <p>
                湖南省益阳市赫山区康复北路益阳基督教协会信义大楼第A101康复北路28号
              </p>
            </td>
            <td valign="center">
              <p>0737-4168369</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>45</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司邵阳双拥路店</p>
            </td>
            <td valign="center">
              <p>湖南省邵阳市大祥区双拥路9号地香儒雅庭6号门面</p>
            </td>
            <td valign="center">
              <p>0739-5275989</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>46</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司长沙桐梓坡路店</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙高新技术开发区麓谷大道698号华润湖南医药有限公司办公楼一楼1068号
              </p>
            </td>
            <td valign="center">
              <p>0731-88136045</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>47</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司常德人民路店</p>
            </td>
            <td valign="center">
              <p>
                湖南省常德市武陵区永安街道新东街社区人民路（美隆苑商居楼1栋103号）
              </p>
            </td>
            <td valign="center">
              <p>0736-7202287</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>48</p>
            </td>
            <td valign="center">
              <p>湖南华益润生大药房有限公司长沙河西店</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市岳麓区西湖街道湖南师范大学咸嘉湖校区综合实验大楼2号、3号
              </p>
            </td>
            <td valign="center">
              <p>0731-85631535</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>49</p>
            </td>
            <td valign="center">
              <p>长沙市德雅大药房有限责任公司</p>
            </td>
            <td valign="center">
              <p>（DTP）湖南省肿瘤医院</p>
            </td>
            <td valign="center">
              <p>0731-84817190</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>50</p>
            </td>
            <td valign="center">
              <p>醴陵醴中国药堂有限公司</p>
            </td>
            <td valign="center">
              <p>醴陵市中医院</p>
            </td>
            <td valign="center">
              <p>0731-23677513</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>51</p>
            </td>
            <td valign="center">
              <p>醴陵醴中国药堂有限公司分公司</p>
            </td>
            <td valign="center">
              <p>醴陵市中医院</p>
            </td>
            <td valign="center">
              <p>0731-23726393</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>52</p>
            </td>
            <td valign="center">
              <p>湘潭市一圆心大药房有限公司</p>
            </td>
            <td valign="center">
              <p>湘潭市第一人民医院</p>
            </td>
            <td valign="center">
              <p>0731-55570018</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>53</p>
            </td>
            <td valign="center">
              <p>湘潭市岳塘区蒲永海中医综合诊所</p>
            </td>
            <td valign="center">
              <p>湘潭市第一人民医院</p>
            </td>
            <td valign="center">
              <p>0731-55570018</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>54</p>
            </td>
            <td valign="center">
              <p>怀化德雅药品有限公司</p>
            </td>
            <td valign="center">
              <p>怀化市第一人民医院</p>
            </td>
            <td valign="center">
              <p>0745-8776272</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>55</p>
            </td>
            <td valign="center">
              <p>华润湖南瑞格医药有限公司咸嘉湖益生药号</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市八一路107号</p>
            </td>
            <td valign="center">
              <p>0731-84423023</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>56</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司河西店</p>
            </td>
            <td valign="center">
              <p>长沙市岳麓区咸嘉湖路72号长房西城湾商铺2层</p>
            </td>
            <td valign="center">
              <p>
                0731-84912233<br />
                0731-88612048
              </p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>57</p>
            </td>
            <td valign="center">
              <p>国药控股湖南有限公维安中医门诊部</p>
            </td>
            <td valign="center">
              <p>长沙市岳麓区咸嘉湖路72号长房西城湾商铺2层</p>
            </td>
            <td valign="center">
              <p>17352869306</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>58</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司附一店</p>
            </td>
            <td valign="center">
              <p>
                长沙市开福区清水塘街道芙蓉中路一段319号绿地中心裙房T2栋1层104号
              </p>
            </td>
            <td valign="center">
              <p>
                0731-85525223 <br />
                0731-85525213
              </p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>59</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司雨花店</p>
            </td>
            <td valign="center">
              <p>长沙市人民中路182号101号综合楼门面</p>
            </td>
            <td valign="center">
              <p>
                0731-85525302<br />
                0731-85525303
              </p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>60</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司常德店</p>
            </td>
            <td valign="center">
              <p>
                常德市武陵区启明街道办事处半边街社区水府庙街13号（望江名苑门面6栋105号
              </p>
            </td>
            <td valign="center">
              <p>0736-2588529</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>61</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司怀化店</p>
            </td>
            <td valign="center">
              <p>怀化市鹤城区香洲路牡丹富贵花园53-56号门面</p>
            </td>
            <td valign="center">
              <p>0745-2233360</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>62</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司株洲店</p>
            </td>
            <td valign="center">
              <p>株洲市天元区滨江西路33号中泰财富湘江2栋114号、115号</p>
            </td>
            <td valign="center">
              <p>0731-22161912</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>63</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司湘潭店</p>
            </td>
            <td valign="center">
              <p>湘潭市雨湖区雨湖路123号2栋</p>
            </td>
            <td valign="center">
              <p>0731-58265652</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>64</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司衡阳店</p>
            </td>
            <td valign="center">
              <p>衡阳市石鼓区船山路59号二楼</p>
            </td>
            <td valign="center">
              <p>0734-8151990</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>65</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司岳阳店</p>
            </td>
            <td valign="center">
              <p>岳阳市岳阳楼区东茅岭炮弯巷31号（现岳阳市一人民医院旁）</p>
            </td>
            <td valign="center">
              <p>
                0730-8615530<br />
                0730-8615531
              </p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>66</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司益阳店</p>
            </td>
            <td valign="center">
              <p>益阳市赫山区秀峰中路188号</p>
            </td>
            <td valign="center">
              <p>0737-4116058</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>67</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司娄底店</p>
            </td>
            <td valign="center">
              <p>娄底市娄星区长青街东314号</p>
            </td>
            <td valign="center">
              <p>0738-8285525</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>68</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司邵阳店</p>
            </td>
            <td valign="center">
              <p>邵阳市乾元巷体育局综合楼邵阳市全民健身服务中心4-5号门面</p>
            </td>
            <td valign="center">
              <p>0739-5266706</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>69</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司吉首店</p>
            </td>
            <td valign="center">
              <p>建湘路世纪山水小区38栋103号门面（州人民医院对面）</p>
            </td>
            <td valign="center">
              <p>13974320312</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>70</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司张家界店</p>
            </td>
            <td valign="center">
              <p>张家界永定区古庸路296号2-3号门面</p>
            </td>
            <td valign="center">
              <p>0744-8320545</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>71</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司郴州店</p>
            </td>
            <td valign="center">
              <p>
                湖南省郴州市北湖区燕泉街道青年大道湘南风情康居园18栋门面1012、2012号
              </p>
            </td>
            <td valign="center">
              <p>17308416858</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>72</p>
            </td>
            <td valign="center">
              <p>国药控股湖南维安大药房连锁有限公司永州店</p>
            </td>
            <td valign="center">
              <p>
                湖南省永州市冷水滩区逸云路与永州大道交汇处和睦小区5栋103号二楼
              </p>
            </td>
            <td valign="center">
              <p>0746-2370861</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>73</p>
            </td>
            <td valign="center">
              <p>郴州国药关爱维安大药房（正德向善）</p>
            </td>
            <td valign="center">
              <p>
                湖南省郴州市苏仙区南塔路6号9幢12、115、117号（郴一中心医院南门正对面公交站）
              </p>
            </td>
            <td valign="center">
              <p>0735-2863218</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>74</p>
            </td>
            <td valign="center">
              <p>华润湖南瑞格医药有限公司益生药号</p>
            </td>
            <td valign="center">
              <p>长沙市岳麓区金星北路一段22号恒晟商厦A栋10楼</p>
            </td>
            <td valign="center">
              <p>13755198559</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>75</p>
            </td>
            <td valign="center">
              <p>湖南思派大药房有限公司</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市岳麓区西湖街道咸嘉湖路428号西湖丽景苑1栋102号</p>
            </td>
            <td valign="center">
              <p>0731-82292623</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>76</p>
            </td>
            <td valign="center">
              <p>长沙思派大药房有限公司</p>
            </td>
            <td valign="center">
              <p>长沙市雨花区侯家塘街道人民中路245号雨花大厦一楼商铺1209号</p>
            </td>
            <td valign="center">
              <p>13574804031</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>77</p>
            </td>
            <td valign="center">
              <p>湖南达嘉维康医药产业股份有限公司五一路分店</p>
            </td>
            <td valign="center">
              <p>长沙市芙蓉区五一大道165号</p>
            </td>
            <td valign="center">
              <p>0731-84171129</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>78</p>
            </td>
            <td valign="center">
              <p>湖南达嘉维康医药产业股份有限公司香花路分店</p>
            </td>
            <td valign="center">
              <p>郴州市北湖区香花路香花小区4栋109房</p>
            </td>
            <td valign="center">
              <p>0735-8188008</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>79</p>
            </td>
            <td valign="center">
              <p>湖南达嘉维康医药产业股份有限公司香江城市花园分店</p>
            </td>
            <td valign="center">
              <p>衡阳市高新区解放大道33号香江城市花园10-14栋107号</p>
            </td>
            <td valign="center">
              <p>0734-8528953</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>80</p>
            </td>
            <td valign="center">
              <p>湖南达嘉维康医药产业股份有限公司雨湖路分店</p>
            </td>
            <td valign="center">
              <p>湘潭市雨湖区雨湖路188号</p>
            </td>
            <td valign="center">
              <p>0731-58266516</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>81</p>
            </td>
            <td valign="center">
              <p>湖南达嘉维康医药产业股份有限公司银双路分店</p>
            </td>
            <td valign="center">
              <p>长沙市岳麓区银双路210号</p>
            </td>
            <td valign="center">
              <p>0731-88661122</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>82</p>
            </td>
            <td valign="center">
              <p>京东大药房（湖南）有限公司长沙人民中路店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市雨花区人民中路店105号一层整层</p>
            </td>
            <td valign="center">
              <p>18569513667</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>83</p>
            </td>
            <td valign="center">
              <p>京东大药房（湖南）有限公司长沙咸嘉湖路店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市岳麓区西湖街道咸嘉湖路632号</p>
            </td>
            <td valign="center">
              <p>18774831998</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>84</p>
            </td>
            <td valign="center">
              <p>京东大药房（湖南）有限公司怀化锦溪南路店</p>
            </td>
            <td valign="center">
              <p>湖南省怀化市锦溪南路7幢103、104、105、106</p>
            </td>
            <td valign="center">
              <p>18797566656</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>85</p>
            </td>
            <td valign="center">
              <p>京东大药房（湖南）有限公司郴州国庆南路店</p>
            </td>
            <td valign="center">
              <p>湖南省郴州市北湖区国庆南路29号</p>
            </td>
            <td valign="center">
              <p>13574550405</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>86</p>
            </td>
            <td valign="center">
              <p>湖南海王星辰健康药房连锁有限公司长沙湘雅分店</p>
            </td>
            <td valign="center">
              <p>
                长沙市开福区芙蓉中路一段319号绿地中心T2栋1层106、107、108号（湘雅医院正对面）
              </p>
            </td>
            <td valign="center">
              <p>0731-84688601</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>87</p>
            </td>
            <td valign="center">
              <p>湖南海王星辰健康药房连锁有限公司长沙银双路分店</p>
            </td>
            <td valign="center">
              <p>长沙市岳麓区金星中路528号银谷苑6、7栋108</p>
            </td>
            <td valign="center">
              <p>0731-85719770</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>88</p>
            </td>
            <td valign="center">
              <p>湖南海王星辰健康药房连锁有限公司长沙华翼府分店</p>
            </td>
            <td valign="center">
              <p>
                长沙市雨花区韶山南路123号华翼府商住楼102（长沙市中心医院出口往北180米）
              </p>
            </td>
            <td valign="center">
              <p>0731-85458609</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>89</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司雨花一分店</p>
            </td>
            <td valign="center">
              <p>长沙市雨花区时代阳光大道149号（一号门面）</p>
            </td>
            <td valign="center">
              <p>0731-85079016</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>90</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司雁峰店</p>
            </td>
            <td valign="center">
              <p>湖南省衡阳市雁峰区雁城路5号102（衡阳市中心医院门诊对面）</p>
            </td>
            <td valign="center">
              <p>0734-8196553</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>91</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司岳麓唯善店</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市岳麓区桐梓坡路93、95号（湘雅三医院门诊对面）</p>
            </td>
            <td valign="center">
              <p>0731-85603680</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>92</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司岳麓朝阳店</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市岳麓区麓山路29号青枫大厦106号门面（长沙市四医院门诊对面马路）
              </p>
            </td>
            <td valign="center">
              <p>0731-85010410</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>93</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司邵阳县唯德店</p>
            </td>
            <td valign="center">
              <p>
                邵阳县塘渡口镇芙夷城市广场A栋转角四号门面（邵阳县人民医院前坪20米）
              </p>
            </td>
            <td valign="center">
              <p>0739-6868936</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>94</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司湘乡健康路店</p>
            </td>
            <td valign="center">
              <p>湖南省湘乡市昆仑桥办事处（湘乡人民医院门诊正对面）</p>
            </td>
            <td valign="center">
              <p>0731-56787828</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>95</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司天元唯善店</p>
            </td>
            <td valign="center">
              <p>
                湖南省株洲市天元区滨江南路19号科艺花园门面8栋106号（株洲中心医院西门）
              </p>
            </td>
            <td valign="center">
              <p>0731-28822505</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>96</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司岳塘店</p>
            </td>
            <td valign="center">
              <p>
                湘潭市岳塘区书院路21号东4、5、6号门面（湘潭市第一医院大门右侧门面）
              </p>
            </td>
            <td valign="center">
              <p>0731-58555586</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>97</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司芙蓉中路店</p>
            </td>
            <td valign="center">
              <p>
                长沙市开福区福乐巷17号公园西郡大厦101（地铁6号线湘雅医院站3号出口）
              </p>
            </td>
            <td valign="center">
              <p>0731-85860679</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>98</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司邵阳亲民店</p>
            </td>
            <td valign="center">
              <p>
                湖南省邵阳市大祥区红乾路宏云大厦4-5号门面（邵阳市中心医院老门诊楼50米）
              </p>
            </td>
            <td valign="center">
              <p>0739-5187378</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>99</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司新邵向阳店</p>
            </td>
            <td valign="center">
              <p>
                湖南省邵阳市新邵县酿溪镇新阳路22号（新邵县人民医院门诊对面30米）
              </p>
            </td>
            <td valign="center">
              <p>0739-3101676</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>100</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司邵东县亲民店</p>
            </td>
            <td valign="center">
              <p>湖南邵阳市邵东县解放路46号（邵东县人民医院50米）</p>
            </td>
            <td valign="center">
              <p>0739-2613568</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>101</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司祁阳县唯善店</p>
            </td>
            <td valign="center">
              <p>湖南省永州市祁阳县民生南路192号门面（祁阳县人民医院50米）</p>
            </td>
            <td valign="center">
              <p>0746-3299527</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>102</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司澧县百合园店</p>
            </td>
            <td valign="center">
              <p>
                湖南省澧县澧阳街道办事处康澧百合园27幢108号（澧县人民医院急诊侧门旁）
              </p>
            </td>
            <td valign="center">
              <p>0736-3210583</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>103</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司香江城市花园店</p>
            </td>
            <td valign="center">
              <p>
                衡阳市高新区解放大道33号香江城市10-14栋104室（南华附二医院住院楼50米）
              </p>
            </td>
            <td valign="center">
              <p>0734-8221225</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>104</p>
            </td>
            <td valign="center">
              <p>湖南雅馨药房连锁有限公司娄星唯善店</p>
            </td>
            <td valign="center">
              <p>
                湖南省娄底市娄星区湘阳西街市印刷厂3栋（原1栋）111（娄底市中心医院住院E区出口右侧）
              </p>
            </td>
            <td valign="center">
              <p>0738-8612598</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>105</p>
            </td>
            <td valign="center">
              <p>长沙市芙蓉区人民路雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                长沙市芙蓉区人民路156号第54、55栋第一层门面（湘雅二医院门诊楼旁10米）
              </p>
            </td>
            <td valign="center">
              <p>0731-85125312</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>106</p>
            </td>
            <td valign="center">
              <p>长沙市芙蓉区万顺雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市芙蓉区解放中路239号1-01号桥下门面（省人民医院急诊100米）
              </p>
            </td>
            <td valign="center">
              <p>0731-85181770</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>107</p>
            </td>
            <td valign="center">
              <p>石门县至善雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省常德市石门县渫阳社区渫阳路045号（石门县人民医院大门口10米）
              </p>
            </td>
            <td valign="center">
              <p>18974261697</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>108</p>
            </td>
            <td valign="center">
              <p>长沙市天心区雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省长沙市天心区劳动西路176号长沙市第三医院门诊楼三楼出口</p>
            </td>
            <td valign="center">
              <p>0731-85640677</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>109</p>
            </td>
            <td valign="center">
              <p>长沙市芙蓉区唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市芙蓉区陶瓷城D24栋门面（省人民医院马王堆分院急诊马路对面）
              </p>
            </td>
            <td valign="center">
              <p>0731-84214600</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>110</p>
            </td>
            <td valign="center">
              <p>长沙县唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙县星沙街道星沙大道圆梦花园二期11、12栋22号商铺（长沙市八医院急诊50米）
              </p>
            </td>
            <td valign="center">
              <p>0731-84875537</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>111</p>
            </td>
            <td valign="center">
              <p>宁乡亲民雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省长沙市宁乡县花明社区一环北路348号（近宁乡市人民医院50米）
              </p>
            </td>
            <td valign="center">
              <p>0731-87820817</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>112</p>
            </td>
            <td valign="center">
              <p>浏阳市唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省浏阳市嗣同路豪兴街一弄8号商铺</p>
            </td>
            <td valign="center">
              <p>0731-83699430</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>113</p>
            </td>
            <td valign="center">
              <p>醴陵市唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>醴陵市来龙门街道青云北路1号58号门面（醴陵湘东医院门诊对面）</p>
            </td>
            <td valign="center">
              <p>0731-23550881</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>114</p>
            </td>
            <td valign="center">
              <p>湘潭市万顺雅馨药房</p>
            </td>
            <td valign="center">
              <p>湘潭市雨湖区和平路126号101房（湘潭市中心医院儿科对面）</p>
            </td>
            <td valign="center">
              <p>0731-58256236</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>115</p>
            </td>
            <td valign="center">
              <p>湘潭县万顺雅馨药房</p>
            </td>
            <td valign="center">
              <p>湘潭县易俗河镇玉兰中路424、426号（湘潭县人民医院30米）</p>
            </td>
            <td valign="center">
              <p>0731-57220631</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>116</p>
            </td>
            <td valign="center">
              <p>衡阳市阳光雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省衡阳市石鼓区船山中路321号西湖广场一楼门面（南华附二医院大门右侧60米）
              </p>
            </td>
            <td valign="center">
              <p>0734-8198445</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>117</p>
            </td>
            <td valign="center">
              <p>衡阳市雅馨便民药房</p>
            </td>
            <td valign="center">
              <p>
                衡阳市高新区光辉街25号龙盛花苑28、29号门面（衡阳市中心医院华新分院50米）
              </p>
            </td>
            <td valign="center">
              <p>0734-8192029</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>118</p>
            </td>
            <td valign="center">
              <p>耒阳市唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省衡阳市耒阳市城北路（耒阳市人民医院对面）</p>
            </td>
            <td valign="center">
              <p>0734-4396314</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>119</p>
            </td>
            <td valign="center">
              <p>宁远县雅馨大药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省宁远县文庙街道文星社区九亿广场C114-115-116门面（宁远县人民医院100米）
              </p>
            </td>
            <td valign="center">
              <p>0746-7223806</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>120</p>
            </td>
            <td valign="center">
              <p>永州市旭日雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省永州市冷水滩区永和家园5栋商业302号门面（永州市中心医院100米）
              </p>
            </td>
            <td valign="center">
              <p>
                0746-8379988<br />
                0746-8222300
              </p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>121</p>
            </td>
            <td valign="center">
              <p>道县万顺雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省永州市道县红星西路46号铺左侧门面（道县人民医院80米）</p>
            </td>
            <td valign="center">
              <p>0746-5266091</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>122</p>
            </td>
            <td valign="center">
              <p>怀化市唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省怀化市鹤城区湖天香州路5栋104-105号门面（怀化市人民医院100米）
              </p>
            </td>
            <td valign="center">
              <p>0745-2217478</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>123</p>
            </td>
            <td valign="center">
              <p>吉首市雅馨便民药房</p>
            </td>
            <td valign="center">
              <p>湖南省吉首市乾州办事处世纪大道3栋112（湘西州人民医院100米）</p>
            </td>
            <td valign="center">
              <p>0743-8232611</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>124</p>
            </td>
            <td valign="center">
              <p>吉首市唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省吉首市人民北路88号（湘西州民族中医院门诊正对面）</p>
            </td>
            <td valign="center">
              <p>0743-8235828</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>125</p>
            </td>
            <td valign="center">
              <p>常德市润阳雅馨药房</p>
            </td>
            <td valign="center">
              <p>常德市武陵区滨湖路453号（常德市中医院马路对面）</p>
            </td>
            <td valign="center">
              <p>0736-7273018</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>126</p>
            </td>
            <td valign="center">
              <p>湘乡市唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省湘乡市东风路48号湘乡市二医院门诊大楼01栋107号</p>
            </td>
            <td valign="center">
              <p>0731-56789028</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>127</p>
            </td>
            <td valign="center">
              <p>岳阳市岳阳楼区唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省岳阳市岳阳楼区东茅岭路62号（岳阳市中心医院旁40米）</p>
            </td>
            <td valign="center">
              <p>0730-8331120</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>128</p>
            </td>
            <td valign="center">
              <p>益阳市亲民雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省益阳市赫山区康富北路86、88、90号门面（益阳市中心医院旁100米）
              </p>
            </td>
            <td valign="center">
              <p>0737-4246120</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>129</p>
            </td>
            <td valign="center">
              <p>安化万顺雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省益阳市安化县东坪镇迎春路1210号、1212号（安化县人民医院旁100米）
              </p>
            </td>
            <td valign="center">
              <p>0737-7221825</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>130</p>
            </td>
            <td valign="center">
              <p>郴州市尚善雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省郴州市苏仙区南塔街道南塔路7号（郴州市第一医院门诊对面）
              </p>
            </td>
            <td valign="center">
              <p>0735-2324173</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>131</p>
            </td>
            <td valign="center">
              <p>郴州市馨曙光雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                郴州市苏仙区苏仙岭街道飞虹路龙腾广场四期2、3栋110号（郴州市第四医院旁50米））
              </p>
            </td>
            <td valign="center">
              <p>0735-2324815</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>132</p>
            </td>
            <td valign="center">
              <p>郴州市爱唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省郴州市北湖区人民路街道龙泉路龙泉名邸一期5栋102号（湘南附属医院旁30米）
              </p>
            </td>
            <td valign="center">
              <p>0735-2324172</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>133</p>
            </td>
            <td valign="center">
              <p>资兴市亲民雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省郴州市资兴市唐洞街道晋宁路资兴市人民医院100米（市文体广新局旁边)
              </p>
            </td>
            <td valign="center">
              <p>0735-3320674</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>134</p>
            </td>
            <td valign="center">
              <p>娄底市娄星区旭日雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省娄底市娄星区新星南路1207号（娄底市中心医院急诊对面）</p>
            </td>
            <td valign="center">
              <p>0738-8321598</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>135</p>
            </td>
            <td valign="center">
              <p>涟源市朝阳雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省娄底市涟源市交通路西侧21、22号门面（涟源市人民医院出口正对面）
              </p>
            </td>
            <td valign="center">
              <p>0738-4428528</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>136</p>
            </td>
            <td valign="center">
              <p>隆回县唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省邵阳市隆回县紫霞园社区朝阳路323号（隆回县人民医院出口旁50米）
              </p>
            </td>
            <td valign="center">
              <p>0739-8112529</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>137</p>
            </td>
            <td valign="center">
              <p>新化县唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>湖南省娄底市新化县人民医院门诊出口沿街门面</p>
            </td>
            <td valign="center">
              <p>0738-3307206</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>138</p>
            </td>
            <td valign="center">
              <p>张家界市唯德雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                张家界市永定区人民路102.103号雅馨药房（张家界市人民医院老院旁50米）
              </p>
            </td>
            <td valign="center">
              <p>0744-8224778</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>139</p>
            </td>
            <td valign="center">
              <p>常德市爱德雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                常德柳叶湖旅游度假区柳叶湖街道月亮大道（湘雅常德医院门诊正对面））
              </p>
            </td>
            <td valign="center">
              <p>15386169016</p>
            </td>
          </tr>

          <tr>
            <td valign="center">
              <p>140</p>
            </td>
            <td valign="center">
              <p>常德市武陵区唯善雅馨药房</p>
            </td>
            <td valign="center">
              <p>
                湖南省常德市武陵区启明街道半边街社区人民东路（常德市第一医院儿科对面天桥口）
              </p>
            </td>
            <td valign="center">
              <p>13975699548</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { cdnresources } from '@/util/config'
export default {
  data() {
    return {
      cdnresources
    }
  },
  components: {}
}
</script>

<style scoped lang="scss">
.company-appointment-box {
  min-height: 100vh;
  background: #fff;
  padding-bottom: xvw(40);
  width: 100%;
  overflow: hidden;

  .banner {
    width: 100%;
  }

  .lpitemBox {
    padding: 0 xvw(20);

    .box-title {
      display: flex;
      align-items: center;
      font-size: xvw(28);
      font-weight: 600;
      color: #333333;
      line-height: xvw(40);
      padding: xvw(20) 0;

      .box-text {
        background: linear-gradient(#ffffff 0%, #ffeeee 100%);
      }

      img {
        width: xvw(44);
        height: xvw(25);
        margin-left: xvw(20);
      }
    }

    .yaotable {
      table-layout: fixed;
      border-collapse: collapse;
      width: 100%;
      text-align: center;
      border-color: #ff9695;
      color: #333333;
      font-size: 12px;

      td {
        width: auto;

        p {
          word-break: break-all !important;
          white-space: pre-wrap;
        }
      }

      tr:not([tableHead]) {
        td:first-child {
          width: 30px;
        }

        td:last-child {
          width: 120px;
        }
      }

      .tableHead {
        height: xvw(100);
        background: #ffeded;
      }
    }
  }
}
</style>
